import script from "./OrderModal.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderModal.vue?vue&type=script&setup=true&lang=js"

import "./OrderModal.vue?vue&type=style&index=0&id=e3258c40&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3258c40"]])

export default __exports__